// extracted by mini-css-extract-plugin
module.exports = {"appBackground":"_2EPqy0NPpax6X8-BzX016S","gradient":"_1lrGYVVSkDZ3JKlnjlEZrq"};